import { useEffect, useState } from "react";
import { adminApi, errMsg } from "../api";
import { toast } from "../../components/ui/sonner";

export default function SubmissionsAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const [filter, setFilter] = useState("");

  const load = () => adminApi.get("/admin/submissions").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const setStatus = async (s, status) => {
    try {
      await adminApi.patch(`/admin/submissions/${s.id}`, { status });
      toast.success(`Marked ${status}`);
      load();
      if (open?.id === s.id) setOpen({ ...open, status });
    } catch (e) { toast.error(errMsg(e)); }
  };

  const remove = async (s) => {
    if (!window.confirm("Delete this submission permanently?")) return;
    try { await adminApi.delete(`/admin/submissions/${s.id}`); toast.success("Deleted"); setOpen(null); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const shown = filter ? items.filter((i) => (i.status || "new") === filter) : items;

  return (
    <div data-testid="admin-submissions-page">
      <div className="adm-head">
        <div><h1>Contact submissions</h1><div className="sub">{items.length} total — newest first</div></div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "8px 12px", borderRadius: 9, border: "1.5px solid var(--line)" }} data-testid="filter-status">
          <option value="">All statuses</option>
          <option value="new">New</option>
          <option value="contacted">Contacted</option>
          <option value="closed">Closed</option>
        </select>
      </div>

      <div className="adm-card" style={{ padding: 0, overflow: "auto" }}>
        <table className="adm-table">
          <thead><tr><th>Date</th><th>Name</th><th>Email</th><th>Subject</th><th>Status</th><th style={{ width: 90 }}></th></tr></thead>
          <tbody>
            {shown.map((s) => (
              <tr key={s.id} data-testid={`submission-${s.id}`}>
                <td className="mono">{(s.created_at || "").slice(0, 16).replace("T", " ")}</td>
                <td>{s.name}</td>
                <td>{s.email}</td>
                <td>{s.subject} {s.is_consultation && <span className="adm-badge consult">consultation</span>}</td>
                <td><span className={`adm-badge ${s.status || "new"}`}>{s.status || "new"}</span></td>
                <td><button className="adm-btn ghost sm" onClick={() => setOpen(s)} data-testid={`view-${s.id}`}>View</button></td>
              </tr>
            ))}
            {shown.length === 0 && <tr><td colSpan={6} className="adm-empty">No submissions.</td></tr>}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="adm-card" data-testid="submission-detail" style={{ borderColor: "var(--crimson)" }}>
          <h2>{open.subject} {open.is_consultation && <span className="adm-badge consult">consultation request</span>}</h2>
          <p className="mono" style={{ marginBottom: 10 }}>{open.created_at}</p>
          <p><strong>{open.name}</strong> — {open.email}{open.phone ? ` — ${open.phone}` : ""}</p>
          <p style={{ margin: "14px 0", whiteSpace: "pre-wrap", color: "var(--muted)" }}>{open.message}</p>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {["new", "contacted", "closed"].map((st) => (
              <button key={st} className={`adm-btn ${open.status === st ? "primary" : "ghost"} sm`} onClick={() => setStatus(open, st)} data-testid={`status-${st}`}>
                {st}
              </button>
            ))}
            <button className="adm-btn danger sm" onClick={() => remove(open)} data-testid="delete-submission">Delete</button>
            <button className="adm-btn ghost sm" onClick={() => setOpen(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
